import moment from 'moment-timezone';

// Change these dates to disable networkers from registration and changing their settings
export const closedDates = {
  from: moment.tz('2022-10-11T18:00:00', 'Europe/London'),
  to: moment.tz('2022-10-14T23:59:00', 'Europe/London')
}